// extracted by mini-css-extract-plugin
export default {"container":"B2B2CBreakdown_container__xBvXh"};